<template>
  <div class="f-seal">
    <div :class="type" class="f-seal-bd text-bold">
      <div class="top flex-center">质检</div>
      <div :class="type" class="center font-16">
        {{ time | parseTime('{y}-{m}-{d}') }}
      </div>
      <div class="bottom flex-center">{{ statusText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'success'
    },
    time: {
      type: Number,
      default: 0
    }
  },

  computed: {
    statusText () {
      if (this.type == 'success') {
        return '合格'
      } else if (this.type == 'fail') {
        return '不合格'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.f-seal {
  >.success {
    color: #409eff;
    border: 2px solid #409eff;
  }

  >.fail {
    color: #f56c6c;
    border: 2px solid #f56c6c;
  }

  .f-seal-bd {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    transform: rotate(-20deg);

    .top {
      width: 100%;
      text-indent: 10px;
      letter-spacing: 10px;
      font-size: 18px;
      position: absolute;
      top: 7px;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
    }

    .center {
      width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
    }

    .bottom {
      width: 100%;
      font-size: 18px;
      position: absolute;
      bottom: 7px;
      left: 50%;
      transform: translate3d(-50%, 0, 0);
    }

    .center.success {
      border-top: 2px solid #409eff;
      border-bottom: 2px solid #409eff;
    }

    .center.fail {
      border-top: 2px solid #f56c6c;
      border-bottom: 2px solid #f56c6c;
    }
  }

  .f-seal-bd.success .bottom {
    text-indent: 10px;
    letter-spacing: 10px;
  }
}
</style>